import { Badge } from 'reactstrap';
import {
  PreQualificationStatus,
  PreQualificationResultStatus,
  PreQualificationResultRuleSeverity,
  PreQualificationResultLoggerAction,
} from '../enums/PreQualificationEnum';

interface Props {
  status:
    | PreQualificationStatus
    | PreQualificationResultStatus
    | PreQualificationResultRuleSeverity
    | PreQualificationResultLoggerAction;
  className?: string;
}

const statusConfig = {
  created: {
    label: 'Creado',
    color: 'info',
  },
  under_review: {
    label: 'Revisión',
    color: 'warning',
  },
  active: {
    label: 'Activa',
    color: 'success',
  },
  disabled: {
    label: 'Desactivada',
    color: 'default',
  },
  closed: {
    label: 'Cerrado',
    color: 'danger',
  },
  evaluated: {
    label: 'Evaluado',
    color: 'success',
  },
};

const statusPQResponseConfig = {
  pending: {
    label: 'Pendiente',
    color: 'info',
  },
  approved: {
    label: 'Aprobado',
    color: 'success',
  },
  rejected: {
    label: 'Rechazado',
    color: 'danger',
  },
  evaluated: {
    label: 'Evaluado',
    color: 'info',
  },
  applied: {
    label: 'Aplicado',
    color: 'default',
  },
  na: {
    label: 'N/A',
    color: 'secondary',
  },
};

const severityConfig = {
  blocking: {
    color: 'danger',
    label: 'Bloqueante',
  },
  warning: {
    color: 'warning',
    label: 'Advertencia',
  },
  info: {
    color: 'info',
    label: 'Información',
  },
};

const loggerActionConfig = {
  rules_evaluated: {
    label: 'Reglas Evaluadas',
    color: 'info',
  },
  status_changed: {
    label: 'Estado Cambiado',
    color: 'warning',
  },
  notified_bank: {
    label: 'Banco Notificado',
    color: 'success',
  },
};

const PreQualficationStatusBadge = ({ status, className }: Props) => {
  const config = statusConfig[status as PreQualificationStatus];

  return (
    <Badge color={config.color} className={className}>
      {config.label}
    </Badge>
  );
};

const PreQualificationResultStatusBadge = ({ status, className }: Props) => {
  let config = statusPQResponseConfig[status as PreQualificationResultStatus];

  if (!config) {
    config = statusPQResponseConfig['na'];
  }
  return (
    <Badge color={config.color} className={className}>
      {config.label}
    </Badge>
  );
};

const PreQualificationSeverityBadge = ({
  status: severity,
  className,
}: Props) => {
  const config = severityConfig[severity as PreQualificationResultRuleSeverity];

  return (
    <Badge color={config.color} className={className}>
      {config.label}
    </Badge>
  );
};

const PreQualificationLoggerActionBadge = ({
  status: action,
  className,
}: Props) => {
  const config =
    loggerActionConfig[action as PreQualificationResultLoggerAction];

  return (
    <Badge color={config.color} className={className}>
      {config.label}
    </Badge>
  );
};

export {
  PreQualficationStatusBadge,
  PreQualificationResultStatusBadge,
  PreQualificationSeverityBadge,
  PreQualificationLoggerActionBadge,
};
